import { types } from "../types/types";


export const setData = (data) => ({
    type: types.initdata,
    payload: data
});

export const setCurrentPage = (data) => ({
    type: types.curpage,
    payload: data
});